var map = {
	"./cool_man.jpg": 724,
	"./creeper.jpg": 725,
	"./creeper_and_bomb.jpg": 726,
	"./creeper_head.jpg": 727,
	"./default.jpg": 602,
	"./happy.jpg": 728,
	"./happy_robot.jpg": 729,
	"./logo.jpg": 730,
	"./man.jpg": 731,
	"./neutral.jpg": 732,
	"./sad.jpg": 733
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1374;